import { sessionActions } from '../../store'; // Adjust the path if needed

export async function refreshDriverInstructions(user, dispatch) {
  console.log("Trying to refreshDriverInstructions for user:", user?.id);
  const url = `/api/driver-instructions/user/${user.id}`;
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP error ${response.status}`);
    const data = await response.json();
    dispatch(sessionActions.updateDriverInstructions(data));
    localStorage.setItem(`driverInstructions-${user.id}`, JSON.stringify(data));
    console.log("Trying to refreshDriverInstructions for user:done");
  } catch (err) {
    console.warn("Failed to fetch driverInstructions:", err);
    const cached = localStorage.getItem(`driverInstructions-${user.id}`);
    console.log("Trying to refreshDriverInstructions for failed");
    if (cached) {
      dispatch(sessionActions.updateDriverInstructions(JSON.parse(cached)));
    } else {
      throw new Error("No local driverInstructions data available");
    }
  }
}

